/**
 *
 * 获取用户信息
 * */
import {dispatch, onStoreReady} from "./tools";
import {getLoginToken} from "@/models/userInfo";
import {VIP_ACTIVITY_SWITCHES} from "@/constants/vip-activity";
import {isMaintenanceRoute} from "@/utils/maintenance-route";

onStoreReady(() => {
  if (isMaintenanceRoute(window.location.pathname)) return;

  // 请求更新用户信息
  dispatch({type: 'userInfo/refreshUserInfo'})

  // 初始化站点配置
  dispatch({type: 'site/requestAndSetConfig'})
  dispatch({type: 'site/requestAndSetCustomerInfo'})

  // 朋友圈信息
  if (getLoginToken() && VIP_ACTIVITY_SWITCHES.shareMoments) {
    dispatch({type: 'chatModalControl/updateShareDetail'})
  }

  if (getLoginToken()) {
    dispatch({type: 'vip/updateVipDailyBenefit'})
  }
})
